import i18next from 'i18next';

import {objectToQueryString} from 'web-app/util/url';

import {type ResultsQuery} from './new-list/results/api';

export const getGenderName = (genderFromAPI: 'm' | 'f' | 'all') => {
    switch (genderFromAPI) {
        case 'm':
            return i18next.t('list.boys');
        case 'f':
            return i18next.t('list.girls');
        default:
            return i18next.t('list.all');
    }
};

export const resultsQueryToAPI = (query: ResultsQuery) => {
    const {columns, filters, sortBy, order, limit, offset, kind, institutionId} = query;
    return {
        columns,
        order,
        limit,
        offset,
        kind,
        sortby: sortBy,
        institution: institutionId,
        ...filters,
    };
};

export const resultsQueryToString = (query: ResultsQuery) => {
    const {filters, kind, institutionId, ...rest} = query;
    const queryObject = {
        ...rest,
        ...filters,
    };
    return objectToQueryString(queryObject);
};
